import React from "react";
import { NavLink } from "react-router-dom";
import logo from '../../../assets/gymea-edu-logo.png'
export const NavBarBrand: React.FC = () => {
  return (
    <div className="nav-bar__brand">
      <NavLink to="/">
        <img
          className="nav-bar__logo"
          src={logo}
          alt="Gymea Edu"
        />
      </NavLink>
    </div>
  );
};
